
import {Menu } from 'lucide-react';
import useRegionalStore from '../store/useRegionalStore';
const Header= ({onMenuClick}) => {
  const { province, regency, district } = useRegionalStore();
  const arr = [province,regency,district]
  return (
    <>
    <header  className="bg-white border-b border-slate-200 sticky top-0 z-20">
      <div className="flex items-center justify-between px-8 py-4">
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
        >
          <Menu className="w-5 h-5" />
        </button>
           <div className="flex-1 max-w-2xl">
            <div className='breadcrumb text-xs'>
              Indonesia
              {arr.filter((item) => item != null && item != "" && typeof item != "undefined").map((item, index) => {
             
                if(index == arr.filter((item) => item != null && item != "" && typeof item != "undefined").length - 1){
                  return (
                    <><span>{' > '}</span> <span className='text-blue-600/75 font-medium'>{item}</span></> 
                  )
                }
                
                return (
                  <span>{' > '}{item}</span>
                )
                })}
               
                {/* {`Indonesia  ${(province != "") && (typeof province != "undefined") ? " > " + province : ""}  ${(regency != "") && (typeof regency != "undefined") ? " > " + regency : ""}   ${(district != "") && (typeof district != "undefined") ? " > " + district : ""}`} */}
           </div>
          </div>
         
      </div>
    </header>
     
  </>
  );
};

export default Header;